<template>
  <aside class="page-sidebar-mobile-container">
    <div
      class="page-sidebar-mobile-overlay"
      :class="{ active: show }"
      @click="toggleMenu(false)"
    ></div>

    <div
      class="page-sidebar-mobile d-flex flex-column d-lg-none"
      :class="{ active: show }"
    >
      <div class="header d-flex align-items-center">
        <b-avatar
          class="avatar"
          src="https://assets.admin.wize.pe/images/dropdown-user-avatar.svg"
        >
        </b-avatar>
        <div class="d-flex flex-column pl-3" v-if="user">
          <span class="user-name">{{ username }}</span>
          <span class="email d-inline-block mt-1">{{ user.email }}</span>
        </div>
      </div>

      <div class="grid mt-2 px-2">
        <router-link
          :to="{ name: 'dashboard' }"
          class="link d-flex flex-column justify-content-center align-items-center text-white text-center"
          :class="{ active: $route.name == 'dashboard' }"
        >
          <span class="menu-icon">
            <i class="ri-home-5-line"></i>
          </span>
          Portada
        </router-link>

        <router-link
          :to="{ name: 'employee-list' }"
          class="link d-flex flex-column justify-content-center align-items-center text-white text-center"
          :class="{ active: isEmployeeRoute }"
        >
          <span class="menu-icon">
            <i class="ri-file-user-line"></i>
          </span>
          Colaboradores
        </router-link>

        <router-link
          :to="{ name: 'contracts-list' }"
          class="link d-flex flex-column justify-content-center align-items-center text-white text-center"
          :class="{ active: isContractRoute }"
        >
          <span class="menu-icon">
            <i class="ri-file-list-line"></i>
          </span>
          Contratos
        </router-link>

        <button
          type="button"
          class="link d-flex flex-column justify-content-center align-items-center text-white text-center"
          :class="{ active: isVacationRoute }"
          @click="setSelection('vacations')"
        >
          <span class="menu-icon">
            <i class="ri-calendar-check-line"></i>
          </span>
          Vacaciones
        </button>

        <!-- [HIDDEN-DEV] Descansos médicos
        <router-link
          :to="{ name: 'medical-leave-list' }"
          class="link d-flex flex-column justify-content-center align-items-center text-white text-center"
          :class="{ active: isMedicalLeaveRoute }"
        >
          <span class="menu-icon">
            <i class="ri-heart-pulse-line"></i>
          </span>
          Descansos médicos
        </router-link>
        [/HIDDEN-DEV] -->

        <!-- [HIDDEN-DEV] Asistencia
        <button
          type="button"
          class="link d-flex flex-column justify-content-center align-items-center text-white text-center"
          :class="{ active: isAttendanceRoute }"
          @click="setSelection('attendance')"
        >
          <span class="menu-icon">
            <i class="ri-time-line"></i>
          </span>
          Asistencia
        </button>
        [/HIDDEN-DEV] -->

        <!-- [HIDDEN-DEV] Desc. y adicionales
        <router-link
          :to="{ name: 'payroll-movement-list' }"
          class="link d-flex flex-column justify-content-center align-items-center text-white text-center"
          :class="{ active: isMovementRoute }"
        >
          <span class="menu-icon">
            <i class="ri-exchange-dollar-line"></i>
          </span>
          Desc. y adic.
        </router-link>
        [/HIDDEN-DEV] -->

        <!-- [HIDDEN-DEV] Planillas
        <button
          type="button"
          class="link d-flex flex-column justify-content-center align-items-center text-white text-center"
          :class="{ active: isPayrollRoute }"
          @click="setSelection('payroll')"
        >
          <span class="menu-icon">
            <i class="ri-money-dollar-circle-line"></i>
          </span>
          Planillas
        </button>
        [/HIDDEN-DEV] -->

        <!-- [HIDDEN-DEV] Reclutamiento
        <button
          type="button"
          class="link d-flex flex-column justify-content-center align-items-center text-white text-center"
          :class="{ active: isRecruitmentRoute }"
          @click="setSelection('recruitment')"
        >
          <span class="menu-icon">
            <i class="ri-rocket-line"></i>
          </span>
          Reclutamiento
        </button>
        [/HIDDEN-DEV] -->

        <button
          type="button"
          class="link d-flex flex-column justify-content-center align-items-center text-white text-center"
          :class="{ active: isConfigRoute }"
          @click="setSelection('config')"
        >
          <span class="menu-icon">
            <i class="ri-settings-3-line"></i>
          </span>
          Mantenimiento
        </button>
      </div>

      <div class="menu-list-container">
        <ul class="menu-list list-unstyled" v-if="selection">
          <li v-for="item in getMenuItems" :key="item.text">
            <router-link
              :to="item.route"
              exact-active-class="active"
              class="menu-subitem text-decoration-none"
              ><BulletIcon class="fill-white mr-3" />{{
                item.text
              }}</router-link
            >
          </li>
        </ul>
      </div>

      <button
        type="button"
        class="menu-option d-flex align-items-center"
        @click="logout()"
      >
        <LogoutIcon class="fill-white mr-4" />

        <span class="sidebar-item-text">Cerrar sesión</span>
      </button>

      <div
        class="menu-option classic version d-flex justify-content-between align-items-center"
      >
        <span class="text">V{{ version }} {{ year }}</span>
        <p class="my-0">
          Forjado por <a href="https://wize.pe" target="_blank">Wize</a>
        </p>
      </div>
    </div>
  </aside>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";

import { Constants as LocalConstants } from "@/core/utils";

import { BulletIcon, LogoutIcon, Helpers, LocalStorage } from "wize-admin";
import { SecurityService } from "@/core/services";

export default {
  name: "PageSidebarMobile",
  data() {
    return {
      LocalConstants,
      version: process.env.PACKAGE_VERSION,
      year: new Date().getFullYear(),
      selection: "",
      menuList: [
        /* [HIDDEN-DEV] Planillas
        {
          key: "payroll",
          list: [
            { route: { name: "payroll-list" }, text: "Lista" },
            { route: { name: "payroll-base-batch" }, text: "Carga de planillas" },
            { route: { name: "payroll-status-made-batch-list" }, text: "Cargar abonos" },
            { route: { name: "payroll-type-list" }, text: "Tipos de planilla" },
            { route: { name: "payroll-engine" }, text: "Motor (prueba)" },
          ],
        },
        [/HIDDEN-DEV] */
        /* [HIDDEN-DEV] Reclutamiento
        {
          key: "recruitment",
          list: [
            { route: { name: "job-openings-list" }, text: "Vacantes" },
          ],
        },
        [/HIDDEN-DEV] */
        {
          key: "vacations",
          list: [
            { route: { name: "vacation-requests-list" }, text: "Solicitudes" },
            { route: { name: "vacation-calendar" },      text: "Calendario" },
            { route: { name: "vacation-history" },       text: "Historial" },
          ],
        },
        /* [HIDDEN-DEV] Asistencia
        {
          key: "attendance",
          list: [
            { route: { name: "attendance-grid" },    text: "Control mensual" },
            { route: { name: "attendance-summary" }, text: "Resumen" },
          ],
        },
        [/HIDDEN-DEV] */
        {
          key: "config",
          list: [
            { route: { name: "company-list" },         text: "Empresas" },
            { route: { name: "work-site-list" },       text: "Sedes" },
            { route: { name: "bank-list" },            text: "Bancos" },
            { route: { name: "payroll-concept-list" }, text: "Conceptos remunerativos" },
            { route: { name: "area-list" },            text: "Áreas" },
            { route: { name: "roles-list" },           text: "Cargos" },
            { route: { name: "channel-list" },         text: "Canales" },
            { route: { name: "expense-line-list" },    text: "Líneas de gasto" },
            { route: { name: "pension-entity-list" },  text: "Entidades pensionarias" },
            { route: { name: "document-type-list" },   text: "Tipos de documento" },
            { route: { name: "legal-parameter-list" }, text: "Parámetros legales" },
            { route: { name: "work-schedule-list" },   text: "Horarios" },
          ],
        },
      ],
    };
  },
  mounted() {
    if (this.isPayrollRoute) {
      this.setSelection("payroll");
    } else if (this.isVacationRoute) {
      this.setSelection("vacations");
    } else if (this.isRecruitmentRoute) {
      this.setSelection("recruitment");
    } else if (this.isAttendanceRoute) {
      this.setSelection("attendance");
    } else if (this.isConfigRoute) {
      this.setSelection("config");
    }
  },
  props: {
    show: Boolean,
  },
  components: {
    BulletIcon,
    LogoutIcon,
  },
  watch: {
    "$route.name": function () {
      if (this.currentDevice != "desktop") {
        this.toggleMenu(false);
      }
    },
  },
  methods: {
    ...mapMutations({
      toggleMenu: "app/toggleMenu",
    }),
    setSelection(key) {
      this.selection = key;
    },
    async logout() {
      try {
        await this.$store.dispatch("app/loading", true);
        await SecurityService.logout({refreshToken: LocalStorage.getRefreshToken()})
      } catch (error) {
        console.error(error)
      } finally {
        await this.$store.dispatch("app/loading", false);
        this.$store.dispatch("auth/logout").then(() => this.$router.push({name: "login"}));
      }
    },
  },
  computed: {
    ...mapGetters({
      user: "auth/getUser",
      isMenuOpen: "app/isMenuOpen",
      getCurrentPlan: "app/getCurrentPlan",
      currentDevice: "app/getCurrentDevice",
      business: "app/getBusiness",
      businesses: "app/getBusinesses",
    }),
    username: function () {
      return this.user ? Helpers.capitalizeName(this.user.name) : "";
    },
    getMenuItems() {
      let item = this.menuList.find((item) => item.key == this.selection);
      return item ? item.list : [];
    },
    isEmployeeRoute() {
      return this.$route.name && this.$route.name.includes("employee");
    },
    isContractRoute() {
      return this.$route.name && this.$route.name.includes("contract");
    },
    isVacationRoute() {
      return (
        (this.$route.name && this.$route.name.includes("vacation")) ||
        this.selection === "vacations"
      );
    },
    isMedicalLeaveRoute() {
      return this.$route.name && this.$route.name.includes("medical-leave");
    },
    isAttendanceRoute() {
      return (
        (this.$route.name && this.$route.name.includes("attendance")) ||
        this.selection === "attendance"
      );
    },
    isMovementRoute() {
      return this.$route.name && (
        this.$route.name.includes("payroll-movement") ||
        this.$route.name.includes("movement-group")
      )
    },
    isPayrollRoute() {
      return (
        (this.$route.name && (
          this.$route.name.includes("payroll") &&
          !this.$route.name.includes("payroll-movement")
        )) ||
        this.selection === "payroll"
      );
    },
    isRecruitmentRoute() {
      return (
        (this.$route.name && (
          this.$route.name.includes("job-opening") ||
          this.$route.name.includes("applicant")
        )) ||
        this.selection === "recruitment"
      );
    },
    isConfigRoute() {
      return (
        (this.$route.name && (
          this.$route.name.includes("area") ||
          this.$route.name.includes("company") ||
          this.$route.name.includes("roles") ||
          this.$route.name.includes("pension-entity") ||
          this.$route.name.includes("work-site") ||
          this.$route.name.includes("document-type") ||
          this.$route.name.includes("legal-parameter") ||
          this.$route.name.includes("work-schedule") ||
          this.$route.name.includes("payroll-concept")
        )) ||
        this.selection === "config"
      );
    },
  },
};
</script>

<style lang="stylus">
@import "../../styles/components/layout/page-sidebar-mobile.styl"
</style>
